export const en = {
    adaptive: 'Adaptive',
    filter: 'Filter',
    'sizes-title': 'Sizes'
};
